<template>
  <el-dialog
    title="标签分配"
    :visible.sync="visible"
    width="360px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClose">
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="110px">
      <el-form-item label="分配号段：">{{ options.min }}-{{ options.max }}</el-form-item>
      <el-form-item
        label="开始序号："
        prop="beginTagNo">
        <el-input-number
          v-model="info.beginTagNo"
          :max="options.max"
          :min="options.min"
          :precision="0"></el-input-number>
      </el-form-item>
      <el-form-item
        label="结束序号："
        prop="endTagNo">
        <el-input-number
          v-model="info.endTagNo"
          :max="options.max"
          :min="options.min"
          :precision="0"></el-input-number>
      </el-form-item>
      <el-form-item label="未分配数量：">{{ options.maxAssignCount }}个</el-form-item>
      <el-form-item
        label="分配数量："
        prop="tagCount">
        <el-input-number
          v-model="info.tagCount"
          :max="options.maxAssignCount"
          :min="1"
          :precision="0"></el-input-number>
      </el-form-item>
      <el-form-item
        label="鉴定中心："
        prop="roomId">
        <room-select
          v-if="visible"
          v-model="info.roomId"
          :showAll="false" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import AppraiseLable from '../../../../service/appraiseLable'
import RoomSelect from '../../room-select.vue'
export default {
  name: 'LabelAllocationModal',
  components: { RoomSelect },
  data() {
    return {
      loading: false,
      visible: false,
      info: { tagSegId: null, roomId: null, tagCount: undefined, beginTagNo: undefined, endTagNo: undefined },
      options: { min: 0, max: 0, maxAssignCount: 0 },
      rules: {
        tagCount: [{ required: true, message: '请输入分配的标签数量', trigger: 'blur' }],
        beginTagNo: [{ required: true, message: '请输入开始序号', trigger: 'blur' }],
        endTagNo: [{ required: true, message: '请输入结束序号', trigger: 'blur' }],
        roomId: [{ required: true, message: '请选择鉴定中心', trigger: 'change' }]
      }
    }
  },
  methods: {
    handleClose() {
      this.info = { ...this.info, ...this.$options.data().info }
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const { tagCount, beginTagNo, endTagNo } = this.info
          if (endTagNo < beginTagNo) {
            this.$message.error('结束序号不能小于开始序号')
            return
          }
          const tagCount1 = endTagNo - beginTagNo + 1
          if (tagCount > tagCount1) {
            this.$message.error('分配数量不能大于结束序号减去开始序号')
            return
          }
          const title = tagCount < tagCount1 * 0.9 ? `实际分配数量（${tagCount}个）小于标签数量(${tagCount1}个)的90%，是否继续？` : `是否确认分配${tagCount}个标签`
          this.$confirm(title, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
            .then(() => {
              this.addtagsegment()
            })
        }
      })
    },
    addtagsegment() {
      this.loading = true
      AppraiseLable.assigntagsegment({ ...this.info })
        .then(res => {
          this.loading = false
          const { result, message } = res.data
          if ([0].includes(result)) {
            this.$message.success('生产成功')
            this.visible = false
            this.$emit('fetch')
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    init(options = {}, formData = {}) {
      this.options = { ...this.options, ...options }
      this.info = { ...this.info, ...formData }
      this.visible = true
    }
  }
}
</script>
